import { useState } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { useLocale } from "../i18n";
import { CommandForm } from "./CommandForm";
import { ReadPanel } from "./ReadPanel";
import type { Screen } from "./screens";
import type { Context, RecordValue } from "./types";
import "../styles/season-teams.css";

export function SeasonTeams({ context, actorId, screen, revision, onCreate, onChanged }: {
  context: Context; actorId: string; screen: Screen; revision: number; onCreate: () => void; onChanged: () => void;
}) {
  const { w } = useLocale();
  const [action, setAction] = useState<{ name: string; team: RecordValue }>();
  const [locked, setLocked] = useState(false);
  const actions = screen.writes.filter(([name]) => name !== "groupCreate");
  const selectedAction = action && actions.find(([name]) => name === action.name);
  return <div className="event-season-teams">
    <section className="event-step-tools event-participant-tools" aria-label={w("الفرق", "Teams")}>
      <div className="event-step-heading"><h3>{w("الفرق", "Teams")}</h3><p>{w("أنشئ فريقاً", "Create a team")}</p></div>
      {screen.writes.some(([name]) => name === "groupCreate") && <button type="button" className="primary" disabled={locked} onClick={onCreate}><PlusIcon aria-hidden="true" />{w("إنشاء فريق", "Create team")}</button>}
    </section>
    {action && selectedAction ? <div className="event-team-action-editor">
      <button type="button" className="text-button" disabled={locked} onClick={() => setAction(undefined)}>{w("العودة إلى الفرق المسجلة", "Back to registered teams")}</button>
      <p className="event-team-action-target">{w("الفريق", "Team")}: <strong>{String(action.team.name)}</strong></p>
      <CommandForm key={`${action.team.partyId}:${action.name}`} name={action.name} title={w(selectedAction[1], selectedAction[2])} context={context} actorId={actorId}
        fixedQuery={action.name === "groupMember" ? { partyId: action.team.partyId, entryId: "" } : { entryId: action.team.entryId }}
        onLock={setLocked} onCancel={() => setAction(undefined)} onChanged={onChanged} />
    </div> : <ReadPanel name="groups" title={w("الفرق المسجلة", "Registered teams")} context={context} revision={revision}
      onLock={setLocked} teamActions={actions} onTeamAction={(name, team) => setAction({ name, team })} />}
  </div>;
}
